import { autoinject, bindable } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';

@autoinject
export class Delivery {
  @bindable productionOrderId: number;
  @bindable onSave: (params: { canNavigateOnSave: boolean }) => void;

  constructor() {}

  protected attached() {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }
  }

  @AsyncErrorHandler
  protected handleSave() {
    if (this.onSave) {
      this.onSave({ canNavigateOnSave: true });
    }
  }
}
